import client from './index';

export default {
  async deposit(value: number, userName: string, playerToken: string) {
    const response = await client.post(
      '/v2/player/deposit-money',
      {
        amount: value,
        gatewayUserName: userName,
      },
      {
        headers: {'player-token': playerToken},
      }
    );
    return response.data;
  },
};
